import "@mdi/font/css/materialdesignicons.css"
import Vue from "vue";
import Vuetify from "vuetify";

// VCurrencyField
import VCurrencyField from "v-currency-field";
Vue.use(VCurrencyField, {
    locale: "kr-KR",
    decimalLength: 0,
    autoDecimalMode: false,
    defaultValue: 0,
    min: null,
    max: null,
    valueAsInteger: false,
    allowNegative: true,
});

Vue.use(Vuetify);

export const basicTheme = {
    themes: {
        light: {
            primary: {
                lighten5: "#FFF6F8",
                lighten4: "#FFE9EC",
                lighten3: "#FFDBE0",
                lighten2: "#FFCCD4",
                lighten1: "#FFC1CA",
                base: "#FFB6C1",
                darken1: "#FFAFBB",
                darken2: "#FFA6B3",
                darken3: "#FF9EAB",
                darken4: "#FF8E9E",
            },
            secondary: {
                lighten5: "#F8F7F3",
                lighten4: "#E9E1D1",
                lighten3: "#DBCDB2",
                lighten2: "#CDB893",
                lighten1: "#C2A97C",
                base: "#B79A65",
                darken1: "#B0925D",
                darken2: "#A78853",
                darken3: "#9F7E49",
                darken4: "#906C37",
            },
            accent: {
                lighten5: "#E5ECFF",
                lighten4: "#BFD0FF",
                lighten3: "#94B1FF",
                lighten2: "#6991FF",
                lighten1: "#497AFF",
                base: "#2962FF",
                darken1: "#245AFF",
                darken2: "#1F50FF",
                darken3: "#1946FF",
                darken4: "#0F34FF",
            },
            grey: {
                lighten5: "#F6F6F7",
                lighten4: "#EAEBED",
                lighten3: "#CACDD1",
                lighten2: "#A7ACB2",
                lighten1: "#848B93",
                base: "#4F5965",
                darken1: "#3F4853",
                darken2: "#363E49",
                darken3: "#262E37",
                darken4: "#171C21",
            },
            amber: {
                lighten1: "#f4c923",
            },
            navy: {
                lighten1: "#0A1326",
            },
            success: "#4CAF50",
            warning: "#FFC107",
            error: "#FF5252",
            info: "#2196F3",
            anchor: "inherit",
        },
    },
    options: { customProperties: true },
};

export const consoleTheme = {
    themes: {
        light: {
            primary: "#00C73C",
            secondary: "#445163",
            accent: "#00C73C",
            info: "#2D3539",
            content: "#EDF0F5",
            anchor: "#333",
        },
    },
};

/**
 *
 * @param {(basicTheme|consoleTheme)} theme
 * @returns
 */
export default function (theme) {
    return new Vuetify({
        lang: {
            locales: { ko: require("vuetify/lib/locale/ko") },
            current: "ko",
        },
        breakpoint: {
            mobileBreakpoint: "md",
            thresholds: {
                xs: 576,
                sm: 768,
                md: 1024,
                lg: 1200,
            },
            scrollBarWidth: 0,
        },
        theme: theme || basicTheme,
    });
}
